
	export default {
		components: {},
		data: function () {
			return {};
		},
		computed: {
			getButtonText() {
				return this.buttonText != "" ? this.buttonText : "Select";
			},

			imageUrl() {
				if (this.options.Images[0]) return this.options.Images[0].url;
				return "";
			},
		},
		props: ["options", "buttonText"],
		created: function () {},
		mounted: function () {},
		methods: {},
	};
